export default __webpack_public_path__ + "static/media/2-Contract-Signing.473e12ab.jpeg";